import React from 'react';
import Grid from '@material-ui/core/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { List, ListItem, ListItemIcon, useMediaQuery } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';
import PlaceIcon from '@mui/icons-material/Place';
import FacebookIcon from '@mui/icons-material/Facebook';
import PhoneEnabledIcon from '@mui/icons-material/PhoneEnabled';
import AttachEmailIcon from '@mui/icons-material/AttachEmail';
import Divider from '@mui/material/Divider';

import { makeStyles } from '@material-ui/core/styles';
import bg from '../../assets/img/location.jpg';
import qr from '../../assets/img/qrcode.jpg';

const useStyles = makeStyles((theme) => ({
  rootGeneral: {
    flexGrow: 1,
    margin: '1% 2% 1% 2%',
    fontFamily: '"Montserrat", "Roboto", "Helvetica", "Arial", sans-serif',
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.up('xl')]: {
      margin: '2% auto',
      maxWidth: '1400px',
    },
    [theme.breakpoints.up('lg')]: {
      margin: '1.5% auto',
      maxWidth: '1200px',
    },
    [theme.breakpoints.down('md')]: {
      margin: '2% 1%',
    },
    [theme.breakpoints.down('sm')]: {
      margin: '1% 0.5%',
    },
  },
  root: {
    flexGrow: 1,
    margin: '0 2%',
    padding: '0 3% 5% 3%',
    [theme.breakpoints.up('xl')]: {
      padding: '0 4% 5% 4%',
      margin: '0 3%',
    },
    [theme.breakpoints.up('lg')]: {
      padding: '0 3.5% 5% 3.5%',
      margin: '0 2.5%',
    },
    [theme.breakpoints.down('sm')]: {
      margin: '0 1%',
      padding: '0 2% 3% 2%',
    },
  },
  nav: {
    width: '100%',
  },
  articleText: {
    lineHeight: '1.5em',
    fontSize: '1.3em',
    textAlign: 'justify',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.1em',
      lineHeight: '1.4em',
      textAlign: 'left',
    },
  },
  fieldset: {
    border: '4px',
    borderStyle: 'solid',
    borderColor: '#26516F',
    borderRadius: '50px',
    margin: '10px 20px',
    [theme.breakpoints.down('md')]: {
      margin: '10px 15px',
      borderRadius: '30px',
      border: '3px solid #26516F',
    },
    [theme.breakpoints.down('sm')]: {
      margin: '10px 5px',
      borderRadius: '20px',
      border: '2px solid #26516F',
    },
  },
  legend: {
    color: '#26516F',
    fontSize: '2em',
    fontWeight: '700',
    marginLeft: '30px',
    padding: '0 10px',
    maxWidth: '210px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.5em',
      marginLeft: '15px',
      padding: '0 5px',
      maxWidth: '160px',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.3em',
      marginLeft: '10px',
      maxWidth: '140px',
    },
  },
  article: {
    fontSize: '1.8em',
    fontWeight: '600',
    textDecoration: 'underline',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.4em',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.2em',
    },
  },
}));

function ContactUs() {
  const classes = useStyles();
  const isMobile = useMediaQuery('(max-width:600px)');
  const isTablet = useMediaQuery('(max-width:960px)');

  return (
    <div className={classes.rootGeneral}>
      <div className={classes.nav}>

        {/*ABOUT US*/}
        <Grid item l={12} xs={12}>
          <fieldset className={classes.fieldset}>
            <legend className={classes.legend}>Contact Us</legend>
            <div className={classes.root}>
              <Box sx={{ px: { xs: 1, sm: 2, lg: 10 } }}>
                <Box className="frame" mb={isMobile ? 3 : 4}>
                  <Box className="card-head">
                    <Box display="flex" justifyContent="center" alignItems="center" flexWrap='wrap'>
                      <PlaceIcon sx={{ fontSize: isMobile ? '1.2rem' : '1.5rem', mr: 0.5 }} />
                      <Typography 
                        sx={{ 
                          fontSize: isMobile ? '1rem' : '1.2rem',
                          fontWeight: 'bold',
                        }}
                      >
                        Visit Us
                      </Typography>
                    </Box>
                  </Box>
                  <Box p={2}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <img
                          src={bg}
                          alt="KabahagiBackground"
                          style={{ 
                            width: "100%", 
                            height: "auto",
                            borderRadius: isMobile ? '8px' : '12px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} md={6} container justifyContent="center" alignItems="center">
                        <Box>
                          <Typography sx={{ fontSize: { xs: '16px', sm: '20px', md: '24px' }, textAlign: 'center', fontWeight: 'bold' }}>
                            Kabahagi Center for Children with Disabilities
                          </Typography>
                          <Typography sx={{ fontSize: { xs: '12px', sm: '14px', md: '16px' }, textAlign: 'center', marginTop: '8px' }}>
                            Serbisyong Bayan Park, Barangay Batasan Hills, Quezon City
                          </Typography>

                          <Divider variant="middle" sx={{ margin: { xs: '15px 0', sm: '25px 0', md: '35px 0' } }} />
                          <Grid container spacing={isMobile ? 1 : 2}>
                            <Grid item xs={12} md={6}>
                              <Box sx={{ fontSize: { xs: '12px', sm: '16px', md: '20px' }, textAlign: 'center' }}>
                                <Typography fontWeight="bold">
                                  Monday - Thursday
                                </Typography>
                                8:00AM to 5:00PM
                              </Box>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Box sx={{ fontSize: { xs: '12px', sm: '16px', md: '20px' }, textAlign: 'center' }}>
                                <Typography fontWeight="bold">
                                  Friday
                                </Typography>
                                8:00AM to 5:00PM
                              </Box>
                            </Grid>
                          </Grid>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
                <Box className="frame" mb={isMobile ? 3 : 4}>
                  <Box className="card-head">
                    <Box display="flex" justifyContent="center" alignItems="center" flexWrap='wrap'>
                      <FacebookIcon 
                        sx={{ 
                          marginRight: '5px',
                          fontSize: isMobile ? '1.2rem' : '1.5rem',
                        }} 
                      />
                      <Typography 
                        sx={{ 
                          fontSize: isMobile ? '0.9rem' : { xs: '12px', sm: '16px', md: '20px' },
                          fontWeight: 'bold',
                          textAlign: 'center',
                        }}
                      >
                        Like our Facebook Page and Send Us Personal Message:
                      </Typography>
                    </Box>
                  </Box>
                  <Box p={isMobile ? 2 : 3}>
                    <Box textAlign="center">
                      <Typography sx={{ fontSize: { xs: '10px', sm: '10px', md: '20px' }, textAlign: 'center', fontWeight: 'bold' }}>
                        <a href="https://www.facebook.com/KabahagiCenter/" target="_blank" rel="noopener noreferrer" style={{ color: '#000' }}>
                          https://www.facebook.com/KabahagiCenter/
                        </a>
                      </Typography>
                      <img
                        src={qr}
                        alt="KabahagiQR"
                        style={{ 
                          width: isMobile ? "60%" : "40%", 
                          height: "auto",
                          borderRadius: '8px',
                          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                        }}
                      />
                    </Box>
                  </Box>
                </Box>
                <Box className="frame" mb={isMobile ? 3 : 4}>
                  <Box className="card-head">
                    <Box display="flex" justifyContent="center" alignItems="center" flexWrap='wrap'>
                      <PhoneEnabledIcon 
                        sx={{ 
                          marginRight: '5px',
                          fontSize: isMobile ? '1.2rem' : '1.5rem',
                        }} 
                      />
                      <Typography 
                        sx={{ 
                          fontSize: isMobile ? '0.9rem' : { xs: '12px', sm: '16px', md: '20px' },
                          fontWeight: 'bold',
                        }}
                      >
                        Please Call Us At:
                      </Typography>
                    </Box>
                  </Box>
                  <Box className="serviceBody" p={isMobile ? 2 : 3}>
                    <Box textAlign="center">
                      <Typography sx={{ fontSize: { xs: '12px', sm: '16px', md: '20px' }, textAlign: 'center', fontWeight: 'bold' }}>
                        8246-2350 local 103 / 106 / 107
                      </Typography>
                    </Box>
                  </Box>
                </Box>
                <Box className="frame" mb={isMobile ? 3 : 4}>
                  <Box className="card-head">
                    <Box display="flex" justifyContent="center" alignItems="center" flexWrap='wrap'>
                      <AttachEmailIcon 
                        sx={{ 
                          marginRight: '5px',
                          fontSize: isMobile ? '1.2rem' : '1.5rem',
                        }} 
                      />
                      <Typography 
                        sx={{ 
                          fontSize: isMobile ? '0.9rem' : { xs: '12px', sm: '16px', md: '20px' },
                          fontWeight: 'bold',
                        }}
                      >
                        SEND US AN EMAIL AT:
                      </Typography>
                    </Box>
                  </Box>
                  <Box p={isMobile ? 2 : 3}>
                    <Box textAlign="center">
                      <Typography sx={{ fontSize: { xs: '12px', sm: '16px', md: '20px' }, fontWeight: 'bold' }}>
                        <a href="mailto:example@example.com" target="_blank" rel="noopener noreferrer" style={{ color: '#000' }}>
                          qckabahagicenter@quezoncity.gov.ph
                        </a>
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </div>
          </fieldset>
        </Grid>
      </div>
    </div>
  );
}

export default ContactUs;
